import { z } from 'zod';

export const resetCredentialSchema = z.object({
  reason: z.string({ required_error: 'Motivo é obrigatório' })
    .trim()
    .min(10, 'Motivo deve ter pelo menos 10 caracteres')
    .max(500, 'Motivo deve ter no máximo 500 caracteres'),
  ticket: z.string({ required_error: 'Ticket é obrigatório' })
    .trim()
    .min(1, 'Ticket é obrigatório')
    .max(100, 'Ticket deve ter no máximo 100 caracteres'),
});

export type ResetCredentialForm = z.infer<typeof resetCredentialSchema>;
